<template>
  <tela-component title="Meus Clientes">
    <!-- Formulário pesquisa cliente -->
    <btn-adicionar-cliente />

    <v-card flat rounded="lg" class="mt-2">
      <v-card-text>
        <v-row dense>
          <v-col cols="12">
            <v-form ref="form">
              <v-row dense>
                <v-col xl="10" lg="10" md="9" cols="12">
                  <v-text-field
                    label="Pesquisar cliente"
                    :placeholder="getPlaceholder()"
                    v-model="pesquisa"
                  ></v-text-field>
                </v-col>
                <v-col xl="2" lg="2" md="3" cols="12" align-self="center">
                  <v-btn
                    color="secondary"
                    :block="isMobile()"
                    :text="!isMobile()"
                    :outlined="isMobile()"
                    rounded
                    class="float-right"
                    @click="buscarClientes()"
                  >
                    <v-icon size="18" class="mr-1">mdi-magnify</v-icon> Buscar
                    clientes</v-btn
                  >
                </v-col>
              </v-row>
            </v-form>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <template v-if="isMobile()">
      <v-progress-linear indeterminate v-if="loading"></v-progress-linear>
      <v-card
        v-else
        v-for="(cliente, i) in clientes"
        :key="i"
        flat
        rounded="lg"
        class="mt-2"
      >
        <v-card-title class="subtitle-1 font-weight-bold">{{
          cliente.nome
        }}</v-card-title>
        <v-card-text>
          <p class="mb-1">
            Matrícula <span class="float-right">{{ cliente.matricula }}</span>
          </p>
          <p class="mb-1">
            Tipo <span class="float-right">{{ cliente.tipo }}</span>
          </p>
          <p class="mb-1">
            CPF/CNPJ <span class="float-right">{{ cliente.cpf_cnpj }}</span>
          </p>
          <p class="mb-1">
            Cidade
            <span class="float-right"
              >{{ cliente.cidade }}/{{ cliente.uf }}</span
            >
          </p>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-row>
            <v-col cols="auto">
              <btn-editar-cliente :cliente="cliente" />
            </v-col>
            <v-col cols="auto">
              <v-btn
                icon
                :to="`/cadpros/${cliente.matricula}/${cliente.nome}`"
                color="secondary"
                ><v-icon>mdi-list-box-outline</v-icon></v-btn
              >
            </v-col>
            <v-col cols="auto">
              <btn-perfil-cliente :cliente="cliente" />
            </v-col>
            <v-col cols="auto">
              <btn-ver-localizacao :cliente="cliente" icon>
                <v-icon color="indigo">mdi-map-marker-outline</v-icon>
              </btn-ver-localizacao>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </template>

    <v-card flat rounded="lg" class="mt-2" v-else>
      <v-card-text>
        <v-data-table
          :items="clientes"
          :headers="headers"
          no-data-text="Nenhum cliente encontrado"
          no-results-text="Nenhum cliente localizado com essa pesquisa"
          :loading="loading"
          loading-text="Aguarde... Carregando clientes..."
          :hide-default-footer="clientes.length == 0"
          item-key="matricula"
        >
          <template v-slot:[`item.cidade`]="{ item }">
            {{ item.cidade }}/{{ item.uf }}
          </template>
          <template v-slot:[`item.actions`]="{ item }">
            <btn-editar-cliente :cliente="item" />
            <btn-cad-pro :cliente="item" />
            <btn-perfil-cliente :cliente="item" />
            <btn-ver-localizacao :cliente="item" icon>
              <v-icon color="indigo">mdi-map-marker-outline</v-icon>
            </btn-ver-localizacao>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </tela-component>
</template>

<script>
import TelaComponent from "@/components/tela/TelaComponent.vue";
import { mapActions, mapMutations, mapState } from "vuex";
import BtnEditarCliente from "@/components/clientes/BtnEditarCliente.vue";
import BtnCadPro from "@/components/cadpro/BtnCadPro.vue";
import BtnPerfilCliente from "@/components/perfil-cliente/BtnPerfilCliente.vue";
import BtnAdicionarCliente from "@/components/clientes/BtnAdicionarCliente.vue";
import BtnVerLocalizacao from "@/components/clientes/BtnVerLocalizacao.vue";

export default {
  components: {
    TelaComponent,
    BtnEditarCliente,
    BtnCadPro,
    BtnPerfilCliente,
    BtnAdicionarCliente,
    BtnVerLocalizacao,
  },
  computed: {
    ...mapState("clientes", ["clientes"]),
    ...mapState("usuario", ["usuarioLogado"]),
  },
  data: () => ({
    loading: false,
    pesquisou: false,
    pesquisa: "",
    headers: [
      { text: "Matrícula", value: "matricula" },
      { text: "Tipo", value: "tipo" },
      { text: "Nome", value: "nome" },
      { text: "CPF/CNPJ", value: "cpf_cnpj" },
      { text: "Cidade", value: "cidade" },
      { text: "", value: "actions", sortable: false, align: "end" },
    ],
  }),
  methods: {
    ...mapActions("clientes", ["getClientes"]),
    ...mapMutations("clientes", ["setClientes"]),
    isMobile() {
      return this.$mq == "sm";
    },
    getPlaceholder() {
      if (this.usuarioLogado.representante) {
        return "Pesquise por parte do nome, matrícula ou cpf/cnpj...";
      }

      return "Pesquise pelo nome, matrícula ou cpf/cnpj...";
    },
    async buscarClientes() {
      this.loading = true;
      this.setClientes(await this.getClientes({ pesquisa: this.pesquisa }));
      this.loading = false;
    },
  },
};
</script>

<style>
</style>